import { getParsedNumber } from "../utils/Common";
import Helper from "../utils/Helper";
import dayjs from "dayjs";

export const validateCreateRestaurantData = (params) => {
  const errors = [];

  if (!params.restaurantName) {
    errors.push("Restaurant name is required");
  }

  if (!params.branchName) {
    errors.push("Branch name is required");
  }

  if (!params.address) {
    errors.push("Address is required");
  }

  if (!params.latitude) {
    errors.push("Latitude is required");
  }

  if (!params.longitude) {
    errors.push("Longitude is required");
  }

  if (params.isVatIncluded === 'YES' && params.isSupplementaryDutyIncluded === "NO") {
    errors.push("As vat is included, supplementary duty should be included");
  }

  if (params.isVatIncluded === 'YES' && params.isServiceChargeIncluded === "NO") {
    errors.push("As vat is included, service charge should be included");
  }

  return errors;
};

export const getBranchName = (data) => {
  return Boolean(data.branchName) ? data.branchName : "";
};

export const getLatitude = (data) => {
  return Boolean(data.latitude) ? data.latitude : "";
};

export const getLongitude = (data) => {
  return Boolean(data.longitude) ? data.longitude : "";
};

export const getAddress = (data) => {
  return Boolean(data.address) ? data.address : "";
};

export const getOpenTime = (data) => {
  return Boolean(data.openTime) === false
    ? dayjs(Helper.get12HrTimeOnly("07:00"), "HH:mm A")
    : dayjs(Helper.get12HrTimeOnly(data.openTime), "HH:mm A");
};

export const getCloseTime = (data) => {
  return Boolean(data.closeTime) === false
    ? dayjs(Helper.get12HrTimeOnly("22:30"), "HH:mm A")
    : dayjs(Helper.get12HrTimeOnly(data.closeTime), "HH:mm A");
};

export const getBannerImages = (data) => {
  return Boolean(data.bannerImages) && data.bannerImages.length > 0
    ? data.bannerImages
    : [{ id: `${Date.now()}`, image: "" }];
};

export const getSelectedOpenDays = (data) => {
  return Boolean(data.openDays) ? (data.openDays.length > 0 ? data.openDays : ["Sat"]) : ["Sat"];
};

export const getVat = (data) => {
  return Boolean(data.vat) ? (data.vat > 0 ? data.vat : 0) : 0;
};

export const getServiceCharge = (data) => {
  return Boolean(data.serviceCharge) ? (data.serviceCharge > 0 ? data.serviceCharge : 0) : 0;
};

export const getSelectedPaymentOptions = (data) => {
  return Boolean(data.paymentOptions) ? (data.paymentOptions.length > 0 ? data.paymentOptions : ["CASH"]) : ["CASH"];
};

export const getDefaultInputData = (data) => {
  return {
    countryCode: data.countryCode || "880",
    phone: data.phone || "",
    bin: data.bin || "",
    vatRegNo: data.vatRegNo || "",
    mushak: data.mushak || "",
  };
};

/**
 *
 * @param {*} data
 * @param {*} purpose i.e.: create_validation, edit_validation
 * @returns
 */
export const validateBranchFormData = (data, purpose = "create_validation") => {
  const errors = [];

  if (data.branchName === "") {
    errors.push("Branch name is required.");
  }

  if (data.latitude === "" || data.longitude === "") {
    errors.push("Location (Latitude, Longitude) is required");
  }

  if (data.address === "") {
    errors.push("Address is required");
  }

  if (data.openTime === null || data.closeTime === null) {
    errors.push("Open and Close time are required.");
  } else if (!data.openTime.hasOwnProperty("$H") || !data.closeTime.hasOwnProperty("$H")) {
    errors.push("Open and Close time are required.");
  }

  if (data.status === "" && purpose === "edit_validation") {
    errors.push("Please, select the branch status (Publish / Pending).");
  }

  if (data.openDays?.length == 0) {
    errors.push("Please select a open days.");
  }

  if (data.phone && data.phone.length < 10) {
    errors.push("Please provide a valid phone number");
  }

  if (data.webAddress !== "" && !Helper.isValidWebsiteUrl(data.webAddress)) {
    errors.push("Please enter a valid website address.");
  }

  if (data.socialLink !== "" && !Helper.isValidSocialMedia(data.socialLink)) {
    errors.push("Please enter a valid social media link.");
  }

  if (data.isVatIncluded === 'YES' && data.isSupplementaryDutyIncluded === "NO") {
    errors.push("As vat is included, supplementary duty should be included");
  }

  if (data.isVatIncluded === 'YES' && data.isServiceChargeIncluded === "NO") {
    errors.push("As vat is included, service charge should be included");
  }
  

  return errors;
};

const getUploadedBannerImages = (bannersObj) => {
  const tempBinaryImages = [];
  bannersObj.map((banner) => {
    if (banner.hasOwnProperty("image")) {
      tempBinaryImages.push(banner.image);
    }
  });

  return tempBinaryImages;
};

const getBranchFormData = (branchObj) => {
  const formData = new FormData();

  if (typeof branchObj === "object") {
    for (let key in branchObj) {
      if (branchObj.hasOwnProperty(key)) {
        if (Array.isArray(branchObj[key])) {
          if (key === "bannerImages") {
            branchObj[key].map((banner) => {
              formData.append("bannerImages", banner);
            });
          } else {
            formData.append(`${key}`, branchObj[key]);
          }
        } else {
          formData.append(key, branchObj[key]);
        }
      }
    }
  }

  return formData;
};

/**
 *
 * @param {*} purpose create_validation, update_validation, create_payload, updated_payload
 * @param {*} restaurantId
 * @param {*} branchName
 * @param {*} address
 * @param {*} latitude
 * @param {*} longitude
 * @param {*} openTime
 * @param {*} closeTime
 * @param {*} openDays
 * @param {*} vat
 * @param {*} serviceCharge
 * @param {*} paymentOptions
 * @param {*} logo
 * @param {*} offerImage
 * @param {*} bannerImages
 * @param {*} status
 */
export const getBranchFormDataPayload = (
  purpose,
  isAdmin,
  restaurantId,
  branchName,
  address,
  latitude,
  longitude,
  openTime,
  closeTime,
  openDays,
  vat,
  serviceCharge,
  customersPaymentOptions,
  adminsPaymentOptions,
  logo,
  offerImage,
  bannerImages,
  bin,
  vatRegNo,
  mushak,
  countryCode,
  phone,
  status,
  webAddress,
  socialLink,
  isVatIncluded,
  isSupplementaryDutyIncluded,
  isServiceChargeIncluded
) => {
  let data = {
    restaurantId,
    branchName,
    address,
    latitude,
    longitude,
    openTime,
    closeTime,
    openDays,
    bin,
    vatRegNo,
    mushak,
    vat,
    serviceCharge,
    customersPaymentOptions,
    adminsPaymentOptions,
    logo,
    offerImage,
    bannerImages,
    countryCode,
    phone,
    status,
    webAddress,
    socialLink,
    isVatIncluded,
    isSupplementaryDutyIncluded,
    isServiceChargeIncluded,
  };

  if (purpose === "create_validation" || purpose === "edit_validation") {
    return data;
  }

  data = Object.assign({}, data, {
    openTime: Helper.convertTo24HourFormat(data.openTime),
    closeTime: Helper.convertTo24HourFormat(data.closeTime),
    bannerImages: getUploadedBannerImages(bannerImages),
  });

  if (purpose === "create_payload") {
    return getBranchFormData(data);
  }

  if (typeof logo !== "object") {
    delete data.logo;
  }

  if (typeof offerImage !== "object") {
    delete data.offerImage;
  }

  if (data.bannerImages.length === 0) {
    delete data.bannerImages;
  }

  if (!isAdmin) {
    delete data.status;
  }

  return getBranchFormData(data);
};

export function getKitchenSlipData(kitchenSlip) {
  let foodItems = [];
  let cancelledFoodItems = [];
  let updatedFoodItems = [];
  if (Object.keys(kitchenSlip).length === 0) return;
  Object.keys(kitchenSlip).map((key) => {
    if (key === "items") {
      foodItems = [...kitchenSlip[key].foods, ...kitchenSlip[key].setMenus];
    }
    if (key === "cancelledItems") {
      cancelledFoodItems = [...kitchenSlip[key].foods, ...kitchenSlip[key].setMenus];
    }
    if (key === "updatedItems") {
      updatedFoodItems = [...kitchenSlip[key].foods, ...kitchenSlip[key].setMenus];
    }
  });

  return { foodItems, cancelledFoodItems, updatedFoodItems };
}
